<template>
  <div class="putInStorage">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      show-footer
      :max-height="tableHeight"
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'putInStorage',
    computed: {
      columnList() {
        return [
          { type: 'seq', width: 60, title: this.$t('table.index'), fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.businessInboundNo',
            title: this.$t('batchAdd.putInStorage.businessInboundNo'),
          }, // 业务入库单号
          {
            field: 'serializationJsonData.businessInboundBatchNo',
            title: this.$t('batchAdd.putInStorage.businessInboundBatchNo'),
          }, // 业务入库批次号
          {
            field: 'serializationJsonData.contractNo',
            title: this.$t('batchAdd.putInStorage.contractNo'),
          }, // 采购合同号
          {
            field: 'serializationJsonData.contractDetailNo',
            title: this.$t('batchAdd.putInStorage.contractDetailNo'),
          }, // 采购合同行项目号
          {
            field: 'serializationJsonData.productNo',
            title: this.$t('batchAdd.putInStorage.productNo'),
          }, // 商品编码
          {
            field: 'serializationJsonData.productDesc',
            title: this.$t('batchAdd.putInStorage.productDesc'),
          }, // 商品描述
          {
            field: 'serializationJsonData.productUnit',
            title: this.$t('batchAdd.putInStorage.productUnitName'),
            formatter: this.formatterUnitDict,
          }, // 单位
          {
            field: 'serializationJsonData.storageName',
            title: this.$t('batchAdd.putInStorage.storageName'),
          }, // 仓库
          {
            // 归集数量
            field: 'serializationJsonData.collectionQuantity',
            title: this.$t('batchAdd.salesContract.collectionQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.collectionQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 未归集数量
            field: 'serializationJsonData.unCollectionQuantity',
            title: this.$t('batchAdd.putInStorage.unCollectionQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.unCollectionQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 业务入库单单价
            field: 'serializationJsonData.businessVariablePrice',
            title: this.$t('batchAdd.putInStorage.businessVariablePrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.businessVariablePrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 归集金额
            field: 'serializationJsonData.collectionAmount',
            title: this.$t('batchAdd.putInStorage.collectionAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.collectionAmount
                    )}
                  </span>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      formatterUnitDict({ cellValue }) {
        return this.$baseRequest.getDictValueByType('basic_unit', cellValue);
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.collectionQuantity',
          'serializationJsonData.unCollectionQuantity',
          'serializationJsonData.collectionAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              let point;
              if (column.property.indexOf('Quantity') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
